<template>
    <div class="modal fade" v-bind:id="id" tabindex="-1" role="dialog" v-bind:aria-labelledby="id" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ title }}</h5>
                </div>
                <div class="modal-body">{{ message }}</div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" v-on:click="handleNoClicked()">{{ $t("ui.alert.yes_no_alert.no") }}</button>
                    <button type="button" class="btn btn-primary" v-on:click="handleYesClicked()">{{ $t("ui.alert.yes_no_alert.yes") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "YesNoAlert",

    data() {
        return {
            modal: null
        }
    },

    props: {
        id: String,
        title: String,
        message: String
    },

    methods: {
        show() {
            this.modal = new this.bootstrap.Modal(document.getElementById(this.id));
            this.modal.show();
        },

        hide() {
            this.modal.hide();
        },

        handleYesClicked() {
            this.hide();
            this.$emit("yes");
        },

        handleNoClicked() {
            this.hide();
            this.$emit("no");
        }
    }
}
</script>